import type { RouteRecordRaw } from 'vue-router';

/**
 * Procurement web screens (M8, DECISIONS.md "ADR-073 — Procurement (M8)" backend,
 * "ADR-075 — Procurement web screens" this pass). Follows the parallel-work convention established
 * by `finance.ts`/`manufacturing.ts` — `router.ts` only spreads this array into the app-shell
 * `children`.
 */
export const procurementRoutes: RouteRecordRaw[] = [
  {
    path: 'procurement/approvals',
    name: 'procurement-approvals',
    component: () => import('../pages/procurement/ProcurementApprovalsPage.vue'),
    meta: { requiresModule: 'procurement' },
  },
  // ---- Requisitions ---------------------------------------------------------------------------
  {
    path: 'procurement/requisitions',
    name: 'procurement-requisitions',
    component: () => import('../pages/procurement/RequisitionsPage.vue'),
    meta: { requiresModule: 'procurement' },
  },
  {
    path: 'procurement/requisitions/new',
    name: 'procurement-requisition-new',
    component: () => import('../pages/procurement/CreateRequisitionPage.vue'),
    meta: { requiresModule: 'procurement' },
  },
  {
    path: 'procurement/requisitions/:id',
    name: 'procurement-requisition-detail',
    component: () => import('../pages/procurement/RequisitionDetailPage.vue'),
    props: true,
    meta: { requiresModule: 'procurement' },
  },
  // ---- RFQs -------------------------------------------------------------------------------------
  {
    path: 'procurement/rfqs',
    name: 'procurement-rfqs',
    component: () => import('../pages/procurement/RfqsPage.vue'),
    meta: { requiresModule: 'procurement' },
  },
  {
    path: 'procurement/rfqs/new',
    name: 'procurement-rfq-new',
    component: () => import('../pages/procurement/CreateRfqPage.vue'),
    meta: { requiresModule: 'procurement' },
  },
  {
    path: 'procurement/rfqs/:id',
    name: 'procurement-rfq-detail',
    component: () => import('../pages/procurement/RfqDetailPage.vue'),
    props: true,
    meta: { requiresModule: 'procurement' },
  },
  // ---- Purchase orders ----------------------------------------------------------------------------
  {
    path: 'procurement/orders',
    name: 'procurement-orders',
    component: () => import('../pages/procurement/PurchaseOrdersPage.vue'),
    meta: { requiresModule: 'procurement' },
  },
  {
    path: 'procurement/orders/new',
    name: 'procurement-order-new',
    component: () => import('../pages/procurement/CreatePurchaseOrderPage.vue'),
    meta: { requiresModule: 'procurement' },
  },
  {
    path: 'procurement/orders/:id',
    name: 'procurement-order-detail',
    component: () => import('../pages/procurement/PurchaseOrderDetailPage.vue'),
    props: true,
    meta: { requiresModule: 'procurement' },
  },
  // ---- Supplier invoices --------------------------------------------------------------------------
  {
    path: 'procurement/invoices/new',
    name: 'procurement-invoice-new',
    component: () => import('../pages/procurement/CreateSupplierInvoicePage.vue'),
    meta: { requiresModule: 'procurement' },
  },
  {
    path: 'procurement/invoices/:id',
    name: 'procurement-invoice-detail',
    component: () => import('../pages/procurement/SupplierInvoiceDetailPage.vue'),
    props: true,
    meta: { requiresModule: 'procurement' },
  },
  // ---- Landed cost (ADR-140) ------------------------------------------------------------------
  {
    path: 'procurement/landed-costs',
    name: 'procurement-landed-costs',
    component: () => import('../pages/procurement/LandedCostsPage.vue'),
    meta: { requiresModule: 'procurement' },
  },
];
